<template>
    <div class="isLoadible" style="margin-top: 3em;">
        <h3>
            <span class="title-numbering">2</span>
            Způsob přípravy
        </h3>

        <p>Zde rozepište jednotlivé kroky přípravy pokrmu (např. uvaření těstovin, usmažení zeleniny, apod.). Nezapomeňte vybrat ingredience, které v krocích použijete, <strong>kliknutím na bubliny v pravém sloupci</strong>. Kalkulačka počítá dopady z přípravy pouze s ingrediencemi, které jsou zvýrazněny v zelené bublině. Pro správný výpočet přiřaďte každou ingredienci kliknutím na bublinu u toho kroku přípravy, ve kterém se jí bude využívat nejvíce a nejdéle. Z technických důvodů je možné přiřadit <strong>jednu ingredienci vždy jen k jednomu kroku přípravy</strong>.</p>

        <bao-treatment
                :index="treatment.id"
                :key="treatment.id"
                :appliances="appliances"
                :methods="methods"
                v-for="(treatment, index) in treatments"
                @remove="removeTreatment(index)"
        ></bao-treatment>

        <br>

        <div @click="addTreatment" class="treatmentCreateArea">
            přidat způsob přípravy <i class="fa fa-plus"></i>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import axios from 'axios';

    import BaoTreatment from './treatment';
    import IngredientsStore from '../srores/ingredients-store.js'
    import TreatmentsStore from '../srores/treatments-store.js'

    export default {

        components: {
            BaoTreatment
        },

        data() {
            return {
                ingredientsStore: IngredientsStore,
                treatmentsStore: TreatmentsStore,
                appliances: [],

                methods: []
            }
        },

        computed: {
            treatments() {
                return TreatmentsStore.state.treatments;
            }
        },

        mounted() {
            let vm = this;

            axios.get('/api/appliances')
                .then(function (response) {
                    vm.appliances = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

            axios.get('/api/methods')
                .then(function (response) {
                    vm.methods = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        methods: {
            addTreatment() {
                this.treatmentsStore.addTreatment();
            },

            removeTreatment(index) {
                this.treatments.splice(index, 1);
            }
        }
    }
</script>
